// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import VueScroll from 'vuescroll';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { BootstrapBadge, BootstrapImage, BootstrapLink } from '../../../dsl/front';
import { ImageRatio } from '../../_contracts';
import { prepareImage } from '../../_filters';
import { ReadMoreLink } from '../ReadMoreLink';
import { VUESCROLL_OPTIONS } from './ThumbnailsList.config';
Vue.use(VueScroll, VUESCROLL_OPTIONS);
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
let ThumbnailsList = class ThumbnailsList extends Vue {
    get showBadge() {
        if (!this.listConfig) {
            return false;
        }
        if (typeof this.listConfig.showArticleTags === 'undefined') {
            return false;
        }
        return this.listConfig.showArticleTags;
    }
    resolveArticleImages() {
        this.articles.map((article) => {
            article.thumbnail = this.getThumbnail(article);
        });
    }
    /**
     * Returns the 1st label in the `labels` array.
     *
     * @param article - The article to search within.
     */
    getBadge(article) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        return article.properties.labels.labels[0];
    }
    /**
     * Resolves the applicable `Image` for the current screen resolution.
     */
    getThumbnail(article) {
        if (typeof article.properties.cover !== 'object' || typeof article.properties.cover === null ||
            typeof article.properties.cover.image !== 'object' || article.properties.cover.image === null) {
            return {
                src: '',
                width: null,
                height: null
            };
        }
        return prepareImage(article.properties.cover.image, ImageRatio.Tile, 90, this.isLazy);
    }
    /**
     * Method to get proper article title
     */
    getTitle(article) {
        if (!this.listConfig) {
            return article.title;
        }
        if (!this.listConfig.titleVersion) {
            return article.title;
        }
        if (typeof article.properties.additionalTitles !== 'object' || article.properties.additionalTitles === null ||
            !article.properties.additionalTitles[this.listConfig.titleVersion]) {
            return article.title;
        }
        return article.properties.additionalTitles[this.listConfig.titleVersion];
    }
    /**
     * Determines whether the passed-in article has any badges (labels) associated.
     *
     * @param article - The article to check.
     */
    hasBadges(article) {
        return (typeof article.properties.labels !== 'object' &&
            article.properties.labels !== null &&
            Array.isArray(article.properties.labels) &&
            article.properties.labels.length > 0);
    }
    hasThumbnail(article) {
        return (typeof article.properties.cover === 'object' && typeof article.properties.cover !== null &&
            typeof article.properties.cover.image === 'object' && article.properties.cover.image !== null);
    }
};
__decorate([
    Prop({
        type: Array,
        required: true
    })
], ThumbnailsList.prototype, "articles", void 0);
__decorate([
    Prop({
        type: String,
        required: false,
        default: ''
    })
], ThumbnailsList.prototype, "fallbackImage", void 0);
__decorate([
    Prop({
        type: Boolean,
        required: false,
        default: true
    })
], ThumbnailsList.prototype, "isLazy", void 0);
__decorate([
    Prop({
        type: Object,
        required: false
    })
], ThumbnailsList.prototype, "readMoreLink", void 0);
__decorate([
    Prop({
        type: Object,
        required: true
    })
], ThumbnailsList.prototype, "windowService", void 0);
__decorate([
    Prop({
        type: Object,
        required: false,
        default: () => {
            return { showArticleTags: false };
        }
    })
], ThumbnailsList.prototype, "listConfig", void 0);
__decorate([
    Watch('articles', { immediate: true })
], ThumbnailsList.prototype, "resolveArticleImages", null);
ThumbnailsList = __decorate([
    Component({
        name: 'ThumbnailsList',
        components: {
            BootstrapBadge,
            BootstrapImage,
            BootstrapLink,
            ReadMoreLink,
            VueScroll
        },
        template: `
    <div class="thumbnails-list">
    <div class="thumbnails-list__container" :class="{ '--with-read-more' : readMoreLink }">
      <VueScroll>

        <!-- Articles list -->
        <ul v-if="articles && articles.length" class="list-unstyled">
          <li v-for="(article, i) in articles" :key="article.urlPath" class="thumbnails-list__item">
            <!-- Thumbnail -->
            <BootstrapImage v-if="article.thumbnail" v-bind="article.thumbnail"
                            class="thumbnails-list__item__thumbnail"/>
            <div v-else class="thumbnails-list__item__thumbnail"></div>

            <!-- Badge -->
            <BootstrapBadge v-if="hasBadges(article) && showBadge" :theme="getBadge(article).color"
                            class="thumbnails-list__item__badge">
              {{ getBadge(article).name }}
            </BootstrapBadge>

            <!-- Title -->
            <BootstrapLink :link="{ target: { path: article.urlPath } }" v-clamp="3"
                           class="thumbnails-list__item__title stretched-link">
              {{ getTitle(article) }}
            </BootstrapLink>
          </li>
        </ul>
        <!-- END | Articles list -->

      </VueScroll>
    </div>

    <!-- "Read more" button -->
    <ReadMoreLink v-if="readMoreLink" :link="readMoreLink"
                  class="thumbnails-list__read-more-link"/>

    </div>
  `
    })
], ThumbnailsList);
export { ThumbnailsList };
